import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, requiredStatus = 1 }) => {
  // Mock authentication - in real app this would come from context
  const isAuthenticated = true;
  const userStatus = 3; // 1: needs password change, 2: needs officials, 3: complete

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (userStatus < requiredStatus) {
    // Redirect to appropriate setup step
    switch (userStatus) {
      case 1:
        return <Navigate to="/setup/change-password" replace />;
      case 2:
        return <Navigate to="/setup/add-first-official" replace />;
      default:
        return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;